module.exports = __webpack_public_path__ + "static/media/zunpulseLogo.697a0bc4.svg";